<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!-- <center class="heading"><h3>User Type</h3></center> -->
        <!-- <span v-if="org!=null">
            <center><h3>{{org.name}}</h3></center>
        </span> -->
        <v-row class="bradcrumb">
        <router-link :to="{name: 'role-links' }" class="root">
            Dashboard
        </router-link> /
        <router-link :to="{name: 'admin-master' }" class="root">
            Admin Master
        </router-link>
        <span class="child">/ User Type </span>
    </v-row><br />
        <!-- <center class="heading">
        <h3>User Type</h3>
            </center>
  
        <br /> -->
        <v-card class="card">
        <v-card-title class="heading justify-center">
        <span>User Type</span>
      </v-card-title>
      <v-card-text>
        <span style="color:red;font-size:14px">*NOTE : You can not add new User Type!</span><br />
        <template v-if="sec_mode_list!=null">
            <v-data-table :headers="headers" :items="sec_mode_list" :search="search" class="elevation-1 nowrap">
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search in table" single-line hide-details></v-text-field>
                    </v-toolbar>
                </template>
                <template v-slot:item.isactive="{ item }">
                    <v-icon v-if="item.isactive==true" color="success" class="mr-2">mdi-check-circle-outline</v-icon>
                    <v-icon v-else color="error" class="mr-2">mdi-close-circle-outline</v-icon>
                </template>
                <template v-slot:item.actions="{ item }">
                    <!-- <v-btn :loading="edit_btn_load" @click="editItem(item)" class="link" color="info"> <v-icon title="Activate/Deactivate the User Type">mdi-recycle</v-icon></v-btn> -->
                    <v-switch v-model="item.isactive"  @change="editItem(item)"></v-switch>
                </template>
            </v-data-table>
        </template>
      </v-card-text>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            snackbar_msg: "",
            snackbar: false,
            color: "",
            org: null,
            search: "",
            edit_btn_load: false,
            //
            sec_mode_list: null,
            headers: [
                { text: "Name", value: "name" },
                { text: "Acitve?", value: "isactive" },
                { text: "Toggle", value: "actions", sortable: false },
            ],
        }),
        watch: {},
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            editItem(item) {
                console.log(item);
                this.edit_btn_load = true;
                axios
                    .post("/adminMaster/editAdminUserTypeOperation", item)
                    .then((res) => {
                        this.sec_mode_list = res.data.user_list;
                        this.showSnackbar("#4CAF50", "User Type updated successfully...");
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.edit_btn_load = false;
                        axios;
                    });
            },
        },
        mounted() {
            axios
                .post("/adminMaster/adminUserTypeOperation")
                .then((res) => {
                    this.org = res.data.org;
                    this.sec_mode_list = res.data.user_list;
                    //this.showSnackbar("#4CAF50","Success")
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => {});
        },
    };
</script>
<style scoped>
    .heading {
        background-color: #3f51b5;
        padding: 0.3rem;
        color: white;
    }
</style>
